module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<td>'+
((__t=( studyDate ))==null?'':__t)+
'</td>\n<td>'+
((__t=( physicianName))==null?'':__t)+
'</td>\n<td class="center">\n    <a href="/api/dicom/'+
((__t=( serverId ))==null?'':__t)+
'/'+
((__t=( studyId ))==null?'':__t)+
'"><span class="clickable glyphicon glyphicon-floppy-disk"/></a>\n</td>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/medicals/patient-dicom-row.html
// module id = 379
// module chunks = 0